import { Title } from '@workwhile/web-ui'
import { useNavOptions } from './useNavOptions'

/** Page title in the phone top bar */
export const MobileTopNav = () => {
  const { selectedNavOption } = useNavOptions()

  if (!selectedNavOption) {
    return null
  }

  return (
    <Title order={2} variant={'title'} size={'sm'}>
      {selectedNavOption.text}
    </Title>
  )
}
